'use strict'
require("machinata-reactjs");
require("./config/machinata-cinnamon-reporting-config-bundle.js");
require("./assets/cinnamon/css/machinata-cinnamon-reporting-bundle.min.css");
module.exports = {
    init: function() {
        return;
    }
};
